import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tracker-segment" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.title)
      ? (_openBlock(), _createBlock(_component_SectionTitle, {
          key: 0,
          title: $props.title,
          required: $props.required,
          tooltip: $props.tooltip
        }, null, 8 /* PROPS */, ["title", "required", "tooltip"]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}